import 'keen-slider/keen-slider.min.css'
import KeenSlider from 'keen-slider'
import { createAutoLoopPlugin } from './plugins/createAutoLoopPlugin.js'
import { createDotNavigationPlugin } from './plugins/createDotNavigationPlugin.js'
import { createArrowNavigationPlugin } from './plugins/createArrowNavigationPlugin.js'
import  { navigationWrapper } from './utils/navigationWrapper.js'

const homeSlider = {
  init: () => {
    if (document.getElementById('home-slider')) {

      // Prepare images
      // Images are turned off while page loads
      // Turn them on now
      const sliderImages = document.querySelectorAll('#home-slider .keen-slider__slide');
      sliderImages.forEach((slide) => {
        slide.style.display = 'block';
      });

      const slider = new KeenSlider(
        '#home-slider .new-slider-container',
        {
          loop: true,
          disabled: false,
          defaultAnimation: {
            duration: 2000
          },
          /*breakpoints: {
            '(min-width: 1000px)': {
              loop: true,
              disabled: false
            },
          },*/
        },
        [
          createAutoLoopPlugin(),
          createDotNavigationPlugin(navigationWrapper),
          createArrowNavigationPlugin(navigationWrapper),
        ]
      );
    }
  }
}

export default {
  init: () => {
    window.addEventListener("load", () => {
      homeSlider.init()
    })
  }
}

